/**
 * Content playback gate. IMA lifecycle callbacks (ALL_ADS_COMPLETED, AD_ERROR)
 * must not start the content video when the layout declared autoplay=false:
 * the audit measures user-initiated playback, so only an explicit play()
 * (runner gesture) may unlock resumes.
 */
export function createContentPlayback(video, autoplay) {
  let userStarted = false;
  video.addEventListener('play', () => {
    userStarted = true;
  });
  return {
    /** Play the content video unless autoplay=false and nobody pressed play yet. */
    playContent() {
      if (!autoplay && !userStarted) return;
      video.play();
    },
  };
}
